import { Outlet, useLocation } from 'react-router-dom';
import { ShieldAlert, Bell, UserRound } from 'lucide-react';
import { Link } from 'react-router-dom';

const menuItems = [
  {
    icon: UserRound,
    label: 'Account Information',
    href: '/settings',
    key: 'jhjyreuhcuhctwvxyf',
  },
  {
    icon: ShieldAlert,
    label: 'Security',
    href: '/settings/security',
    key: 'jhjyreoeythfbcwvxyf',
  },
  {
    icon: Bell,
    label: 'Notifications',
    href: '/settings/notifications',
    key: 'jhjyhsdbhyehctwvxyf',
  },
];

const ProfileSettingsIndex = () => {
  const location = useLocation();

  // Check if current path matches menu item path or if it's a subpath
  const isActive = (href) => {
    if (href === '/settings') {
      return location.pathname === '/settings';
    }
    return location.pathname.startsWith(href);
  };

  return (
    <div className="px-10 mt-[10vh]">
      <div className="md:grid md:grid-cols-[4fr_8fr] md:gap-x-10">
        <div>
          <p className="text-xl mb-4">Settings</p>
          <div className="bg-white rounded-lg border border-gray-200 overflow-hidden flex flex-row sm:block">
            {menuItems.map((item) => {
              const currentUrl = isActive(item.href);
              return (
                <Link
                  to={item.href}
                  className={`flex px-5 py-4 items-center gap-x-3 border-b border-b-gray-200 w-11/12 ${
                    currentUrl ? 'sm:border-l-2 sm:border-l-purple-400' : ''
                  }`}
                  state={{ label: item.label }}
                  key={item.key}
                >
                  <item.icon color={`${currentUrl ? '#6F00DD' : '#333333'}`} />
                  <p
                    className={`${
                      currentUrl ? 'text-[#6F00DD]' : 'text-[#333333]'
                    } font-normal hidden sm:block`}
                  >
                    {item.label}
                  </p>
                </Link>
              );
            })}
          </div>
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default ProfileSettingsIndex;
